import { render } from "./TransporterDashboard.vue?vue&type=template&id=d7c99f4c&scoped=true"
import script from "./TransporterDashboard.vue?vue&type=script&lang=js"
export * from "./TransporterDashboard.vue?vue&type=script&lang=js"

import "./TransporterDashboard.vue?vue&type=style&index=0&id=d7c99f4c&lang=css"
import "./TransporterDashboard.vue?vue&type=style&index=1&id=d7c99f4c&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7c99f4c"]])

export default __exports__